import React from 'react';
import { BottomNav as SharedBottomNav } from '@nsi-advisory-services/components';
import { useBottomNavItems } from './navItems';

export default function BottomNav() {
  return <SharedBottomNav items={useBottomNavItems()} />;
}
